/* eslint-disable prefer-const */
export function renameFileToUploadPattern(originalFile: File) {
  let replaced = originalFile.name.replace(/\s/g, '').replace(/-/g, '_');

  return new File([originalFile], replaced, {
    type: originalFile.type,
    lastModified: originalFile.lastModified,
  });
}
